<template>
  <div class="servico-config">
    <template v-if='statusGeral !== ""'>
      <RF-Status :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>
    </template>

    <template v-else-if='statusGeral === ""'>
      <RF-Aba :cpntButtons='buttons'></RF-Aba>
    </template>
  </div>
</template>

<style>
.servico-config > div > table {
  width: calc(100% - 10px);
  min-width: calc(100% - 10px);
  max-width: calc(100% - 10px);
}
</style>

<script>
  export default {
    components: {
      'RF-Aba': () => import('@/components/rf-geral/aba/RF-Aba.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: '',
        buttons: []
      }
    },
    mounted: function () {
      this.pcoConfigIniciar()
    },
    methods: {
      pcoConfigIniciar: function () {
        // ADICIONA A ABA CADASTRO
        this.buttons.push({ nome: 'Categoria', router: this.$router.resolve({ name: 'servico_config_categoria', params: { cts: this.$store.state.token.cts } }).href, aRouterSelect: [ 'servico_config_categoria', 'servico_config_categoria_form' ] })

        // ADICIONA A ABA LOGOTIPO
        if (this.$store.state.pcoAntigo === false && this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 11 ], null, null, null, null, null, false) === true) {
          this.buttons.push({ nome: 'Controle de Processos', router: this.$router.resolve({ name: 'servico_config_pco', params: { cts: this.$store.state.token.cts } }).href, aRouterSelect: [ 'servico_config_pco' ] })
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      }
    }
  }
</script>
